import { openInNewWindow, useAnalyticsActionTracker } from '@cp-shared-10/frontend-ui';
import { MarketingCard } from 'common';
import { Button, Card, Layout } from '@vwfs-bronson/bronson-react';
import React from 'react';

export const MarketingCardUi: React.FC<{ marketingCards?: MarketingCard[]; overrideTitleLevel?: 2 | 3 | 4 | 5 }> = ({
    marketingCards,
    overrideTitleLevel,
}) => {
    const { onAction } = useAnalyticsActionTracker('onLearnMore');

    if (!marketingCards) {
        return null;
    }

    return (
        <Layout>
            {marketingCards.map(({ title, imageUrl, text, buttonLabel, buttonUrl }, index) => (
                <Layout.Item key={index}>
                    <Card
                        element="article"
                        title={title || ''}
                        titleLevel={overrideTitleLevel || 4}
                        imageSrc={imageUrl || ''}
                        imageAlt=""
                        footer={true}
                        buttons={[
                            <Button
                                key={buttonUrl || 'isLoading'}
                                link={true}
                                href={buttonUrl}
                                icon="semantic-forward"
                                iconReversed
                                small
                                onClick={(e) => {
                                    openInNewWindow(buttonUrl)(e);
                                    onAction(title);
                                }}
                            >
                                {buttonLabel}
                            </Button>,
                        ]}
                    >
                        {text}
                    </Card>
                </Layout.Item>
            ))}
        </Layout>
    );
};
